<template>
    <div class="result page">
        <wrapper column :backgroundImage="background" scrollable>
            <div class="image-container">
                <img
                    :src="require(`@/assets/Stage/Result/top.png`)"
                    alt=""
                    width="100%"
                />
            </div>
            <NameDisplay class="name-display" />
            <Transcript />
            <Trophy v-if="trophyFlag" :index="trophyFlag" />
            <div
                v-if="!isInEvent"
                class="go-to-progress-tower"
                @click="$router.push({ name: 'Stage_Tower' })"
            >
                <img
                    src="@/assets/Stage/Result/tower.png"
                    alt=""
                    width="100%"
                />
            </div>
            <ButtonSet :noShare="isInEvent"/>
        </wrapper>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

import PageGeneral from '@/mixins/PageGeneral';
import Transcript from '@/components/Stage/Result/Transcript.vue';
import Trophy from '@/components/Stage/Result/Trophy.vue';
import ButtonSet from '@/components/Stage/Result/ButtonSet.vue';
import NameDisplay from '@/components/General/NameDisplay.vue';

export default {
    mixins: [PageGeneral],
    components: {
        Transcript,
        Trophy,
        ButtonSet,
        NameDisplay,
    },
    computed: {
        ...mapState({
            score: (state) => state.score,
            trophyFlag: (state) => state.trophyFlag,
            defaultName: (state) => state.defaultName,
            user: (state) => state.user,
        }),
        ...mapGetters(['isInEvent']),
    },
    methods: {
        ...mapActions({
            fetchTower: 'fetchTower',
        }),
    },
    async created() {
        await this.fetchTower();
        if (this.score === undefined) this.$router.replace({ name: 'Home' });
    },
};
</script>

<style lang="scss" scoped>
@import "../../scss/main.scss";
.go-to-progress-tower {
    cursor: pointer;
    width: 80%;
}
.name-display {
    transform: translateY(-20px);
}
</style>
